import React from "react";
import { Button, Container, Form } from "react-bootstrap";
import TopHeader from "../Common/TopHeader";
import { Link, useNavigate } from "react-router-dom";
import { PostApiMethod } from "../../core/services/apiService";
import { useAppDispatch, useAppSelector } from "../../core/redux/hooks";
import { DtoSettingsData } from "../../core/dto/settings.dto";
import { setSettingsData } from "../../core/redux/settingsSlice";
import { showToaster } from "../../core/redux/toastSlice";
import constant from "../../core/constant";
import { useForm } from "react-hook-form";
import { DisplayErrorMessages, restrictIntialSpace } from "../../core/services/sharedService";

const EditSettings = () => {
    const [linkLists, setLinkLists] = React.useState<any>([
        { linkName: "", linkVal: "" },
    ]);

    let settingsState = useAppSelector((state) => state.settings);
    const { register, handleSubmit, formState: { errors }, reset } = useForm<any>();
    const [file, setFile] = React.useState(undefined);
    const [callerTuneFile, setCallerTuneFile] = React.useState<File | undefined>(undefined);
    const [isLoading, setIsLoading] = React.useState(false);
    const navigate = useNavigate();
    const [formValue, setFormValue] =
        React.useState<DtoSettingsData>(settingsState);
    const [fileErrorMessage, setFileErrorMessage] = React.useState("");
    const dispatch = useAppDispatch();
    const [linkfieldErrors, setLinkfieldErrors] = React.useState("");
    const LoginUserDetails = useAppSelector((state) => state.auth.users);
    const [ringTone, setRingTone] = React.useState("");
    // const [hummingBirdOrSSM, setHummingBirdOrSSM] = React.useState(formValue.hummingBirdOrSSM);

    React.useEffect(() => {
        reset(setFormValue(settingsState));
        if (settingsState.links) {
            let linksArray = JSON.parse(settingsState.links);
            const formattedLinks: any = [];
            linksArray.forEach((element: { [index: string]: string }) => {
                formattedLinks.push({
                    linkName: Object.keys(element)[0],
                    linkVal: Object.values(element)[0],
                });
            });
            setLinkLists([...formattedLinks]);
            setRingTone(settingsState.ringTone)
            // setHummingBirdOrSSM(settingsState.hummingBirdOrSSM);
        }
    }, [reset, settingsState]);
    const validImageType: any = ["jpg", "png", "jpeg"];
    const validAudioFileType: any = constant.AUDIO_FILE_EXTENSIONS;
    const onFileUpload = React.useCallback(
        (event: any, name: string) => {
            const fileType = event.target.files[0].name.split(".").at(-1);
            if (fileType && name === "file" ? validImageType.includes(fileType) : validAudioFileType?.includes(fileType)) {
                setFileErrorMessage("");
                if (event.target.files[0].size > 20000000) {
                    setFileErrorMessage("Uploaded file size should  be below 20MB.");
                    dispatch(
                        showToaster({
                            dialogBgColor: "bg-danger",
                            dialogMsg: "Uploaded file size should  be below 20MB.",
                            showDialog: true,
                            timer: "5000",
                        })
                    );
                } else {
                    setFileErrorMessage("");
                    setFormValue({
                        ...formValue,
                        [name === "file" ? 'logo' : name === "callerTuneFile" ? 'callerTune' : 'ringTone']: URL.createObjectURL(event.target.files[0]),
                    });
                }
                name === "file" ? setFile(event.target.files[0]) :
                    name === "callerTuneFile" ? setCallerTuneFile(event.target.files[0]) : setRingTone(event.target.files[0]);
            } else {
                setFileErrorMessage(
                    `File type is not supported. Files type must be ${validImageType.join(
                        ", "
                    )}.`
                );
                dispatch(
                    showToaster({
                        dialogBgColor: "bg-danger",
                        dialogMsg: `File type is not supported. Files type must be ${name === "file" ? validImageType.join(
                            ", "
                        ) : validAudioFileType?.join(", ")}.`,
                        showDialog: true,
                        timer: "5000",
                    })
                );
            }
        },
        [formValue]
    );

    const isValidHttpUrl = React.useCallback((urlString: string) => {
        let url;
        try {
            url = new URL(urlString);
        } catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }, []);

    const validateSettingForm = React.useCallback(() => {
        let isFormLinksValid: boolean = true;
        linkLists.forEach((item: any, i: number) => {
            // if (item.linkName === "" || item.linkVal === "") {
            //     setLinkfieldErrors("Link Name and Link Value required");
            //     isFormLinksValid = false;
            //     return false;
            // } else {
            //     if (item.linkName.length > 20) {
            //         setLinkfieldErrors("Enter a valid name (only 20 character allowed)");
            //         isFormLinksValid = false;
            //         return false;
            //     }
            if (!isValidHttpUrl(item.linkVal)) {
                setLinkfieldErrors(`Enter a valid URL ${i + 1}`)
                isFormLinksValid = false;
                return false;
            }
            // }
        });
        if (!isFormLinksValid) {
            return false;
        }
        if (isFormLinksValid && fileErrorMessage !== "") {
            dispatch(
                showToaster({
                    dialogBgColor: "bg-danger",
                    dialogMsg: fileErrorMessage,
                    showDialog: true,
                    timer: "5000",
                })
            );
            return false;
        }
        return true;
    }, [linkLists, isValidHttpUrl]);

    const remove = React.useCallback(
        (e: any, i: any) => {
            linkLists.splice(i, 1);
            setLinkLists([...linkLists]);
            setLinkfieldErrors("");
        },
        [linkLists]
    );

    const addrow = React.useCallback(() => {
        setLinkLists([...linkLists, { linkName: "", linkVal: "" }]);
    }, [linkLists]);

    const handleChange = React.useCallback(
        (event: any, index: any, key: string) => {
            setLinkfieldErrors("");
            linkLists[index][key] = event.target.value;
            setLinkLists([...linkLists]);
        },
        [linkLists, setLinkLists]
    );
    const pageDisable = () => {
        setIsLoading(true);
        document.body.classList.add("screen-disable");
    };

    const pageEnable = () => {
        setIsLoading(false);
        document.body.classList.remove("screen-disable");
    };
    // const handleSubmit = React.useCallback(
    const handleRegistration = React.useCallback(
        (data: any) => {
            let form_data: any = new FormData();
            let formIsValid = validateSettingForm();
            form_data.append("logo", file);
            form_data.append("callerTune", callerTuneFile);
            form_data.append("ringTone", ringTone);
            let linksArray: { [index: string]: string }[] = [];
            linkLists.map((item: any) => {
                linksArray.push({ [item.linkName]: item.linkVal });
            });
            form_data.append("links", JSON.stringify(linksArray));
            form_data.append("call_timeout", data.call_timeout);
            // form_data.append("application_id", data.application_id?.trim());
            // form_data.append("company_id", data.company_id?.trim());
            // form_data.append("storageapi_key", data.storageapi_key?.trim());
            // form_data.append("hummingBirdOrSSM", hummingBirdOrSSM?.toString());
            // form_data.append("ssm_user_id", data.ssm_user_id?.trim());
            // form_data.append("ssm_password", data.ssm_password?.trim());
            form_data.append("notification_timeout", data.notification_timeout);
            // Always send SSM base URL field so clearing it in UI
            // (empty string) will clear the stored value in backend
            if (data.ssm_api_base_url !== undefined && data.ssm_api_base_url !== null) {
                form_data.append("ssm_api_base_url", data.ssm_api_base_url?.trim() || "");
            }
            if (formIsValid) {
                setIsLoading(true);
                pageDisable();
                console.log(form_data, 'input data +++++++++++++++++++++++++++')
                PostApiMethod("admin/vendor/edit", form_data, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }).then((res) => {
                    pageEnable();
                    if (res?.data?.data) {
                        let settingsData: { [index: string]: any } = {};
                        settingsData = {
                            links: "",
                            name: res.data.data.name,
                            domain: res.data.data.domain,
                            id: res.data.data._id,
                            logo: file ? res.data.data.logo : formValue.logo,
                            callerTune: callerTuneFile ? res.data.data.callerTune : formValue.callerTune,
                            ringTone: ringTone ? res.data.data.ringTone : formValue.ringTone,
                            call_timeout: res.data.data.call_timeout,
                            // application_id: res.data.data.application_id,
                            // company_id: res.data.data.company_id,
                            // storageapi_key: res.data.data.storageapi_key,
                            // hummingBirdOrSSM: res.data.data.hummingBirdOrSSM,
                            // ssm_user_id: res.data.data.ssm_user_id,
                            // ssm_password: res.data.data.ssm_password,
                            notification_timeout: res.data.data.notification_timeout,
                            ssm_api_base_url: res.data.data.ssm_api_base_url
                        };
                        if (res.data.data.links) {
                            settingsData["links"] = res.data.data.links;
                        }
                        dispatch(setSettingsData(settingsData));
                        navigate(constant.SETTING);
                        dispatch(
                            showToaster({
                                dialogBgColor: "bg-success",
                                dialogMsg: "Settings successfully updated.",
                                showDialog: true,
                                timer: "5000",
                            })
                        );
                    }
                    setIsLoading(false);
                })
                    .catch((err) => {
                        pageEnable();
                        dispatch(
                            showToaster({
                                dialogBgColor: "bg-danger",
                                dialogMsg: DisplayErrorMessages(err) ? DisplayErrorMessages(err) : "Something went wrong!",
                                showDialog: true,
                                timer: "5000",
                            })
                        );
                    });
            }
        },
        // [linkLists, file, validateSettingForm, callerTuneFile, ringTone, hummingBirdOrSSM]
        [linkLists, file, validateSettingForm, callerTuneFile, ringTone]
    );

    const deleteRingToneFile = React.useCallback(() => {
        setRingTone("");
        setFormValue({
            ...formValue,
            ['ringTone']: "",
        });
    }, [formValue]);

    // const toggleValues = (e: any) => {
    //     console.log(e.target.checked.toString(), 'e.target.checked.toString()');
    //     // setHummingBirdOrSSM(e.target.checked.toString());
    //     console.log(e.target.value, '&&&&&&&&&&&&&&&&&&&&&&&&& value +++++++++++++++++++++++++++');
    //     console.log(e.target.checked, '&&&&&&&&&&&&&&&&&&&&&&&&& value +++++++++++++++++++++++++++');
    // }

    return (
        <>
            <Container fluid>
                <TopHeader heading="Edit Settings" className="mb-3" />
                {/* <Form onSubmit={handleSubmit}> */}
                <Form onSubmit={handleSubmit(handleRegistration)}>
                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Name
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                value={formValue.name}
                                disabled
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Domain
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                value={formValue.domain}
                                disabled
                                className="form-control"
                            />
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                SSM Base URL
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="text"
                                {...register('ssm_api_base_url')}
                                onKeyDown={(e) => restrictIntialSpace(e)}
                                defaultValue={formValue.ssm_api_base_url || ""}
                                placeholder="https://customer-wrapper.ssm-erp.com"
                                className="form-control"
                            />
                            {/* <small className="text-muted">Customer-specific SSM API endpoint (optional)</small> */}
                        </div>
                    </div>

                    {/* <fieldset className="border col-md-8 p-2 mt-2 mb-4" style={{ borderRadius: '5px' }}>
                        <legend className="float-none w-auto m-0">PMS Integration Information</legend>

                        <div className="row mb-2">
                            <div className="col-md-6">
                                <label>PMS</label>
                            </div>
                            <div className="col-md-6">
                                <input type="checkbox" id="toggle" defaultChecked={formValue.hummingBirdOrSSM === "true" ? true : false} onChange={(e) => { toggleValues(e) }} className="toggleCheckbox" />
                                <label htmlFor="toggle" className="toggleContainer">
                                    <div>HummingBird</div>
                                    <div>SSM</div>
                                </label>
                            </div>
                        </div>
                    {
                        hummingBirdOrSSM === "true" ?
                            (
                                <>
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>SSM USER ID</label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                {...register('ssm_user_id', { required: true })}
                                                onKeyDown={(e) => restrictIntialSpace(e)}
                                                defaultValue={(formValue.ssm_user_id && formValue.ssm_user_id !== "undefined") ? formValue.ssm_user_id : ""}
                                                className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                            />
                                            {errors.ssm_user_id?.type === "required" && <small className="text-danger">SSM User ID is required</small>}
                                        </div>
                                    </div>

                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>SSM PASSWORD</label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                {...register('ssm_password', { required: true })}
                                                onKeyDown={(e) => restrictIntialSpace(e)}
                                                defaultValue={(formValue.ssm_password && formValue.ssm_password !== "undefined") ? formValue.ssm_password : ""}
                                                className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                            />
                                            {errors.ssm_password?.type === "required" && <small className="text-danger">SSM PASSWORD is required</small>}
                                        </div>
                                    </div>
                                </>

                            ) :
                            (
                                <>
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>RCM Application ID</label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                {...register('application_id', { minLength: 30, maxLength: 50 })}
                                                onKeyDown={(e) => restrictIntialSpace(e)}
                                                defaultValue={(formValue.application_id && formValue.application_id !== "undefined") ? formValue.application_id : ""}
                                                className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                            />
                                            {errors.application_id?.type === "minLength" && <small className="text-danger">Minimum 30 characters required</small>}
                                            {errors.application_id?.type === "maxLength" && <small className="text-danger">Maximum 50 characters allowed</small>}
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>Customer PMS Company ID</label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                {...register('company_id', { minLength: 5, maxLength: 25 })}
                                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                                defaultValue={(formValue.company_id && formValue.company_id !== "undefined") ? formValue.company_id : ""}
                                                className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                            />
                                            {errors.company_id?.type === "minLength" && <small className="text-danger">Minimum 5 characters required</small>}
                                            {errors.company_id?.type === "maxLength" && <small className="text-danger">Maximum 25 characters allowed</small>}
                                        </div>
                                    </div>
                                    <div className="row mb-2">
                                        <div className="col-md-6">
                                            <label>
                                                RCM API Key
                                            </label>
                                        </div>
                                        <div className="col-md-6">
                                            <input
                                                type="text"
                                                {...register('storageapi_key', { minLength: 27, maxLength: 47 })}
                                                onKeyDown={(e) => { restrictIntialSpace(e) }}
                                                defaultValue={(formValue.storageapi_key && formValue.storageapi_key !== "undefined") ? formValue.storageapi_key : ""}
                                                className="form-control" readOnly={(LoginUserDetails.role == "super_admin" ? false : true)}
                                            />
                                            {errors.storageapi_key?.type === "minLength" && <small className="text-danger">Minimum 27 characters required</small>}
                                            {errors.storageapi_key?.type === "maxLength" && <small className="text-danger">Maximum 47 characters allowed</small>}
                                        </div>
                                    </div>
                                </>
                            )

                    }




                </fieldset> */}
                    <div className="row mb-2">
                        <div className="col-md-4">
                            {linkLists.length === 0 && <span>Link</span>}
                        </div>
                        <div className="col-md-4">
                            <button
                                type="button"
                                onClick={addrow}
                                className="btn btn-primary btn-sm app-button-color add-link"
                            >
                                Add link
                            </button>
                        </div>

                        {linkfieldErrors && <span className="text-center text-danger mt-2" >{linkfieldErrors}</span>}

                    </div>

                    {linkLists.map((linkDetails: any, i: number) => (
                        <div className="row mb-2" key={i}>
                            <div className="col-md-4">
                                <label>
                                    Link {i + 1}
                                    <span className="text-danger">*</span>
                                </label>
                            </div>
                            <div className="col-md-2 mb-2">
                                <input
                                    type="text"
                                    value={linkDetails.linkName}
                                    {
                                    ...register("linkName" + i, { required: true, maxLength: 20, onChange: (e) => { handleChange(e, i, "linkName") } })
                                    }
                                    className="form-control"
                                    placeholder="Name"
                                />
                                {errors[`linkName${i}`]?.type === "required" && <small className='text-danger text-center' >{"link name " + (i + 1) + " is required"}</small>}
                                {errors[`linkName${i}`]?.type === "maxLength" && <small className='text-danger text-center' >Maximum 20 characters is allowed</small>}
                            </div>
                            <div className="col-md-2 mb-2">
                                <input
                                    type="text"
                                    {
                                    ...register("linkVal" + i, { required: true, onChange: (e) => { handleChange(e, i, "linkVal") } })
                                    }
                                    value={linkDetails.linkVal}
                                    className="form-control"
                                    placeholder="Link Here"
                                />
                                {errors[`linkVal${i}`]?.type === "required" && <small className='text-danger text-center' >{"link value " + (i + 1) + " is required"}</small>}
                            </div>
                            <div className="col-md-4">
                                <button
                                    type="button"
                                    onClick={(e) => {
                                        remove(e, i);
                                    }}
                                    className={"btn btn-danger btn-sm remove_" + i}
                                >
                                    Remove
                                </button>
                            </div>
                        </div>
                    ))}

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Call Timeout (Seconds) <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="number"
                                defaultValue={formValue.call_timeout ? formValue.call_timeout : ""}
                                {...register('call_timeout', { required: true, validate: (value) => (parseInt((value)) >= 10 && parseInt(value) <= 60) })}
                                className="form-control"
                            />
                            {errors.call_timeout?.type === "required" && <small className='text-danger' >Call Timeout is required</small>}
                            {errors.call_timeout?.type === "validate" && <small className='text-danger' >Please enter Call Timeout value between 10 and 60</small>}
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Kiosk Motion Notification Video Timeout (Minutes) <span className="text-danger">*</span>
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="number"
                                defaultValue={formValue.notification_timeout ? formValue.notification_timeout : ""}
                                {...register('notification_timeout', { required: true, validate: (value) => (parseInt((value)) >= 2 && parseInt(value) <= 15) })}
                                className="form-control"
                            />
                            {errors.notification_timeout?.type === "required" && <small className='text-danger' >Kiosk Motion Notification Video Timeout is required</small>}
                            {errors.notification_timeout?.type === "validate" && <small className='text-danger' >Please enter Kiosk Motion Notification Video Timeout value between 2 and 15</small>}
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Caller Tune
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="file"
                                name="callerTuneFile"
                                accept="audio/*"
                                className="form-control"
                                onChange={(e) => {
                                    onFileUpload(e, "callerTuneFile");
                                }}
                            />
                            <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                            <audio src={formValue.callerTune} controls>
                                <source src={formValue.callerTune} />
                            </audio>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Notification Ringtone
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="file"
                                name="ringTone"
                                accept="audio/*"
                                className="form-control"
                                onChange={(e) => {
                                    onFileUpload(e, "ringTone");
                                }}
                            />
                            <small className="text-primary">Supported formats : {validAudioFileType?.join(", ")} </small><br />
                            <audio src={formValue.ringTone} controls>
                                <source src={formValue.ringTone} />
                            </audio>
                        </div>
                        <div className='col-md-1 p-0 mt-1'>
                            <span onClick={deleteRingToneFile} ><i className="bi bi-trash text-danger m-1" style={{ fontSize: 24 }}></i></span>
                        </div>
                    </div>

                    <div className="row mb-2">
                        <div className="col-md-4">
                            <label>
                                Logo
                            </label>
                        </div>
                        <div className="col-md-4">
                            <input
                                type="file"
                                name="file"
                                accept="image/*"
                                className="form-control"
                                onChange={(e) => {
                                    onFileUpload(e, 'file');
                                }}
                            />
                            <small className="text-primary">Supported formats : {validImageType.join(", ")} </small><br />
                            <img
                                alt=""
                                src={formValue.logo}
                                style={{ maxWidth: 200 }}
                                height="auto"
                                className="d-inline-block mt-3"
                            />
                        </div>
                    </div>
                    <div className="row mb-2">
                        <div className="col-md-2"></div>
                        <div className="text-center">
                            <Button
                                type="submit"
                                id="submit-settings"
                                className="app-button-color"
                            >
                                {isLoading && <span className="spinner-border text-white mr-1" style={{ width: '18px', height: "18px" }} role="status"></span>} Submit
                            </Button>
                            <Link to={constant.SETTING}>
                                <Button
                                    type="button"
                                    id="cancel-settings"
                                    className="btn btn-secondary m-2"
                                >
                                    Cancel
                                </Button>
                            </Link>
                        </div>
                    </div>
                </Form>
            </Container >
        </>
    );
};

export default EditSettings;
